import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const PrivacyPolicyComponent = () => {
  return (
    <div className="container px-4 pt-5 mt-5 ">
      <h2 className="mb-4">Privacy Policy</h2>
      <p className="text-muted">
        Rush Hub & Rush Valet Go ("we," "our," or "us") are committed to
        protecting your privacy. This Privacy Policy outlines how we collect,
        use, store, and protect your personal information when you use our
        mobile applications and related services.
      </p>

      <div>
        <h4>1. Information We Collect</h4>
        <h5 className="mt-3">A. Information You Provide Directly</h5>
        <ul>
          <li>
            <strong>Phone Number:</strong> Required for OTP-based authentication
            and user identification.
          </li>
        </ul>
        <h5 className="mt-3">B. Automatically Collected Data</h5>
        <ul>
          <li>
            <strong>Device Information:</strong> Includes device model,
            operating system, and app version for performance optimization.
          </li>
          <li>
            <strong>IP Address:</strong> Collected for security, fraud
            prevention, and compliance purposes.
          </li>
          <li>
            <strong>Usage Data:</strong> Includes login activities and
            task-related information to improve user experience.
          </li>
        </ul>
      </div>

      <div>
        <h4>2. How We Use Your Data</h4>
        <ul>
          <li>Authenticate users through OTP-based login.</li>
          <li>Facilitate valet task assignment and management.</li>
          <li>Enhance the security of our services and prevent fraud.</li>
          <li>Monitor app performance and improve functionality.</li>
        </ul>
      </div>

      <div>
        <h4>3. Data Sharing and Third Parties</h4>
        <ul>
          <li>
            We <strong>do NOT</strong> sell, trade, or share your data with
            third parties for marketing purposes.
          </li>
          <li>
            Your data may be processed by third-party service providers (such as
            authentication and cloud hosting services) strictly for app
            functionality.
          </li>
          <li>
            We ensure that all third-party providers comply with strict data
            protection regulations.
          </li>
        </ul>
      </div>

      <div>
        <h4>4. Data Security Measures</h4>
        <ul>
          <li>
            <strong>Data Encryption:</strong> All transmitted and stored data is
            encrypted to prevent unauthorized access.
          </li>
          <li>
            <strong>Access Control:</strong> Only authorized personnel can
            access necessary data.
          </li>
          <li>
            <strong>Regular Security Audits:</strong> We continuously monitor
            and enhance our security protocols.
          </li>
        </ul>
      </div>

      <div>
        <h4>5. User Rights & Control</h4>
        <ul>
          <li>
            <strong>Access & Correction:</strong> Users can request access to
            their stored personal data and update it as necessary.
          </li>
          <li>
            <strong>Data Deletion:</strong> Users can request account deletion
            and removal of all associated data by contacting us at{" "}
            <a href="mailto:support@gorush.co">support@gorush.co</a>.
          </li>
          <li>
            <strong>Opting Out:</strong> Since phone number collection is
            required for login, opting out means users will no longer be able to
            use our services.
          </li>
        </ul>
      </div>

      <div>
        <h4>6. Data Retention Policy</h4>
        <p>
          We retain user data only as long as necessary to fulfill service
          requirements. If an account is inactive for an extended period, we may
          delete the associated data in compliance with data retention laws.
        </p>
      </div>

      <div>
        <h4>7. Children's Privacy</h4>
        <p>
          Our services are not intended for individuals under the age of 18. We
          do not knowingly collect personal data from minors. If we become aware
          of such data collection, we will delete it immediately.
        </p>
      </div>

      <div>
        <h4>8. Changes to This Privacy Policy</h4>
        <p>
          We may update this Privacy Policy from time to time. Users will be
          notified of significant changes through app notifications or email.
          Continued use of our services after an update constitutes acceptance
          of the revised policy.
        </p>
      </div>

      <div>
        <h4>9. Contact Us</h4>
        <p>
          For any questions or concerns regarding this Privacy Policy, please
          contact us at:
        </p>
        <p>
          📩 Email: <a href="mailto:support@gorush.co">support@gorush.co</a>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyComponent;
